import React, { useMemo } from "react";
import clsx from "clsx";
import { Box, Chip } from '@curves/ui-base';
import { formatVal, isEmpty } from "@Util/utils";

/** 依 InBody 分數回傳等級：90+ 優秀、80-89 良好、70-79 標準、60-69 一般、<60 需注意 */
const getScoreGrade = score => {
	if (score >= 90) return { text: "優秀😁", key: "exemplary" };
	if (score >= 80) return { text: "良好😆", key: "good" };
	if (score >= 70) return { text: "標準😊", key: "normal" };
	if (score >= 60) return { text: "一般🙂", key: "fair" };
	return { text: "需注意😥", key: "poor" };
};

const InbodyScoreBox = ({ className, score = 0, deltaInbodyScore }) => {
	const grade = getScoreGrade(score);

	const deltaSection = useMemo(
		() =>
			!isEmpty(deltaInbodyScore) ? (
				<Chip
					className="inbody-score-box__chip"
					color={deltaInbodyScore > 0 ? "success" : deltaInbodyScore < 0 ? "error" : "info"}
					size="small"
					label={` ${formatVal(deltaInbodyScore)} 分`}
				/>
			) : null,
		// eslint-disable-next-line
		[deltaInbodyScore],
	);

	return (
		<Box className={"inbody-score-box-wrapper"}>
			<Box className={clsx("inbody-score-box", className)}>
				<Box>
					<div className={"inbody-score-box__value"}>
						<span className={"inbody-score-box__score"}>{score}</span>
						<span>分</span>
					</div>
				</Box>
				<Box>
					<div className={"inbody-score-box__status"}>
						{deltaSection}
						<span className={"inbody-score-box__status-text"}>{grade.text}</span>
					</div>
				</Box>
			</Box>
		</Box>
	);
};

export default InbodyScoreBox;
